import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import {
    FormControl,
    UntypedFormGroup,
    UntypedFormArray,
    Validators,
} from "@angular/forms";
import { Observable } from "rxjs";

import { ValidatableComponent } from "../../components/base.component";
import { Strings as Constants, ANLASSAUSWAHL } from "../../app.constants";

import {
    ConsultationService,
    GlobalOccasion,
    GlobalOccasionSection,
    GlobalOccasionEntry,
    Protocol,
    ConsultationDate,
    Attachment,
} from "../../services/consultation.service";

import * as moment from "moment";
import { ChangeDetectionStrategy } from "@angular/core";
import { Store } from "@ngrx/store";
import { RootState } from "../../store/root";
import { stateBuilder } from "../../store/utils";
import { Validity, ValidityMap } from "../../store/validity/state";
import { PersistenceService } from "../../store/model/persistence.service";
import { createConsultationDate } from "../../data/model-utils";

@Component({
    selector: "zbd-global-occasion",
    templateUrl: "global-occasion.component.html",
    styleUrls: [`./global-occasion.component.css`],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalOccasionComponent
    extends ValidatableComponent
    implements OnInit
{
    state$: Observable<LocalState>;
    validity$: Observable<Validity>;

    constructor(
        private consultationService: ConsultationService,
        public persistence: PersistenceService,
        store: Store<RootState>,
    ) {
        super();
        this.state$ = LocalState.create(store);
        this.validity$ = store.select<Validity>(
            (s) => s.validity.occasion.global,
        );
    }

    ngOnInit() {
        this.form = new UntypedFormGroup({
            sectionListForm: new UntypedFormGroup({
                globalOccasionSections: new UntypedFormArray([]),
            }),
        });
    }

    addConsultationDate_(globalOccasion: GlobalOccasion) {
        return () => {
            this.persistence.addGlobalOccasion_ConsultationDates(
                globalOccasion,
                createConsultationDate(),
            );
        };
    }

    addAttachment(globalOccasion: GlobalOccasion) {
        return (attachment: Attachment, content: File): void => {
            this.persistence.addAttachment(
                "GlobalOccasions",
                globalOccasion,
                "Attachments",
                attachment,
                content,
            );
        };
    }
}

export class LocalState {
    globalOccasion: GlobalOccasion;

    static create(store: Store<RootState>): Observable<LocalState> {
        return stateBuilder(store, new LocalState()).apply(
            "globalOccasion",
            (s) => s.model.ConsultationProcess.Protocol.GlobalOccasion,
        ).state$;
    }
}
